"use client";

import { useRef } from "react";
import { useServerInsertedHTML } from "next/navigation";

/** Insert article JSON-LD into the server-rendered head, including streamed pages. */
export function BlogSchemaHead({ schema }: { schema: object[] }) {
    const inserted = useRef(false);

    useServerInsertedHTML(() => {
        if (inserted.current) return null;
        inserted.current = true;

        return (
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(schema).replace(/</g, "\\u003c"),
                }}
            />
        );
    });

    return null;
}
